import Logger from "../../../core/internal/logger"
import { ScheduledJob, Scheduler } from "../../../core/internal/scheduler/Scheduler"
import { Clock } from "../../../core/internal/util/TimeUtil"
import { InAppMessageScheduleListener } from "../schedule/InAppMessageScheduleListener"
import { InAppMessageDelay } from "./InAppMessageDelay"
import { InAppMessageDelayTask } from "./InAppMessageDelayTask"

export class InAppMessageDelayScheduler {
  private _listener: InAppMessageScheduleListener | undefined
  constructor(private readonly clock: Clock, private readonly scheduler: Scheduler) {}

  get listener(): InAppMessageScheduleListener | undefined {
    return this._listener
  }
  set listener(listener: InAppMessageScheduleListener | undefined) {
    this._listener = listener
  }

  schedule(delay: InAppMessageDelay): InAppMessageDelayTask {
    const job = this.scheduler.schedule(delay.delayMillis, () => this.delayCommand(delay))
    return new ScheduledInAppMessageDelayTask(delay, job)
  }

  delayCommand(delay: InAppMessageDelay) {
    const now = this.clock.currentMillis()
    const request = delay.schedule.toRequest("DELAYED", now)

    this.listener?.onSchedule(request)
  }
}

export class ScheduledInAppMessageDelayTask implements InAppMessageDelayTask {
  constructor(public readonly delay: InAppMessageDelay, private readonly job: ScheduledJob) {}
  cancel() {
    this.job.cancel()
    Logger.log.debug(`InAppMessageDelay cancelled: ${this.delay}`)
  }
}
